import { FC } from 'react';
import classNames from 'classnames';

import { ReactComponent as BadgeSvg } from 'assets/images/icons/badge.svg';

type PropTypes = {
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  className?: string;
}

const Badge: FC<PropTypes> = ({title, className, type}) => {
  return (
    <div className={classNames('badge', `badge--${type}`, className)}>
      {className === 'dashboard__badge' && <BadgeSvg />}
      {title}
    </div>
  );
};

export default Badge;